import { MIN_CONFIDENCE_DISPLAY, type Opinion } from '@/types';

/** The display rule (doc §8.3): below the threshold is hidden, never deleted. */
export function visibleOpinions(opinions: Opinion[]): Opinion[] {
  return opinions
    .filter((o) => o.confidence >= MIN_CONFIDENCE_DISPLAY)
    .sort((a, b) => b.confidence - a.confidence);
}
